import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=4736025e&scoped=true"
import script from "./ProductsEdit.vue?vue&type=script&lang=js"
export * from "./ProductsEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductsEdit.vue?vue&type=style&index=0&id=4736025e&prod&scoped=true&lang=css"
import style1 from "./ProductsEdit.vue?vue&type=style&index=1&id=4736025e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736025e",
  null
  
)

export default component.exports